import { PhoneContactResponseType, PhoneResponseType } from '../../../constants'
import {
  UpdateContactPhoneDto,
  UserPhoneDto
} from '../../../types/swaggerTypes'

export const normalizeAccountValue = (value?: string | null): string => {
  const trimmed = value?.trim() ?? ''
  return trimmed.toLowerCase() === 'null' ? '' : trimmed
}

export const displayAccountValue = (value?: string | null): string =>
  normalizeAccountValue(value) || '--'

export type AccountPhone = Omit<UserPhoneDto, 'phoneId'> & {
  phoneId?: number | string
}

export const getAccountPhones = (phones: UserPhoneDto[]): AccountPhone[] => {
  const fields: AccountPhone[] = phones.map((phone) => ({
    ...phone,
    countryCode: normalizeAccountValue(phone.countryCode),
    areaCode: normalizeAccountValue(phone.areaCode),
    phoneNumber: normalizeAccountValue(phone.phoneNumber),
    phoneExtension: normalizeAccountValue(phone.phoneExtension)
  }))

  for (const phoneType of [
    PhoneResponseType.MOBILE,
    PhoneResponseType.FAX,
    PhoneResponseType.GEN
  ]) {
    if (!fields.some((phone) => phone.phoneType === phoneType)) {
      fields.push({
        phoneType,
        countryCode: '',
        areaCode: '',
        phoneNumber: '',
        phoneExtension: ''
      })
    }
  }

  return fields
}

export const prepareAccountPhones = (
  fields: AccountPhone[],
  originalPhones: UserPhoneDto[],
  editedIndex: number
): UpdateContactPhoneDto[] =>
  fields.flatMap((phone, index) => {
    const original = originalPhones.find(
      (record) => record.phoneId.toString() === phone.phoneId?.toString()
    )

    // Placeholders belong to the form only. Preserve untouched server records.
    if (index !== editedIndex) {
      return original
        ? [
            {
              ...original,
              phoneId: original.phoneId.toString(),
              requestType: PhoneContactResponseType.UPDATE
            }
          ]
        : []
    }

    if (!phone.phoneNumber && !original) return []

    return [
      {
        ...phone,
        phoneId: original?.phoneId.toString() ?? '',
        requestType: original
          ? phone.phoneNumber
            ? PhoneContactResponseType.UPDATE
            : PhoneContactResponseType.DELETE
          : PhoneContactResponseType.CREATE
      }
    ]
  })
